import fetchBuilder from 'fetch-retry'

const REQUEST_TIMEOUT = 3000

function buildFetch(url: string, retries = 0, opts?: RequestInit) {
    let options: RequestInit
    if (opts) {
        if (opts.headers && isFlippApiUrl(url)) {
            ;(opts.headers as string[][]).push(['Platform', 'web'])
        }
        options = { ...opts }
    } else if (isFlippApiUrl(url)) {
        options = { headers: [['Platform', 'web']] } as RequestInit
    }
    return fetchBuilder(fetch, {
        retryDelay: REQUEST_TIMEOUT,
        retryOn: function (attempt, error, response) {
            if (attempt > retries) return false

            // retry on any network error, or 4xx or 5xx status codes
            if (error !== null || (response as any).status >= 400) {
                console.log(`retrying, attempt number ${attempt + 1}`)
                return true
            }
        },
    })(url, options)
}

export function fetchRaw(url: string, opts?: RequestInit, retries?: number) {
    return buildFetch(url, retries, opts)
}

export function fetchJSON<T>(
    url: string,
    opts?: RequestInit,
    retries?: number
) {
    return buildFetch(url, retries, opts).then((res: any) => res.json() as T)
}

export class FetchError extends Error {
    private _body: any
    private _status: number

    constructor(message: string, status: number, body?: any) {
        super(message)
        this._body = body
        this._status = status
        /* Manually set the prototype for this object to FetchError. This was broken as of Typescript 2.1. See:
         *https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work*/
        ;(this as any).__proto__ = FetchError.prototype
    }

    get status() {
        return this._status
    }

    get body() {
        return this._body
    }
}

export function fetchImage(url: string, crossOrigin?: boolean) {
    return new Promise<HTMLImageElement>((resolve) => {
        const img = document.createElement('img')
        if (crossOrigin) img.crossOrigin = 'anonymous'
        img.onload = function () {
            resolve(img)
        }
        img.src = url
    })
}

function isFlippApiUrl(url: string): boolean {
    return ['https://flyers-ng.flippback.com'].some((apiUrl) => {
        return url.includes(apiUrl)
    })
}
